import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IQualifyingOffense } from "../interfaces/qualifying-offense";

@Injectable({
  providedIn: 'root'
})
export class QualifyingOffenseService {
    private rootUrl: string = "/api/qualifying-offenses";

    constructor(private httpClient: HttpClient) { }

    public getQualifyingOffenses(sourceId: number): Observable<IQualifyingOffense[]> {
        let url = this.rootUrl + "?sourceId=" + sourceId;
        return this.httpClient.get<IQualifyingOffense[]>(url);
    }
}
